/**
 * Brochure hierarchy: Category → Systems.
 * Each system row = product line (SYSTEM column) + DESCRIPTION + APPLICATION.
 */

export const PRODUCT_PILLARS = [
  {
    slug: 'epoxy-flooring',
    title: 'Epoxy Flooring',
    overview: {
      what: 'Epoxy resin flooring systems for industrial, pharmaceutical, and hygienic areas.',
      whereUsed:
        'Formulation, aseptic production, packaging, stores, loading bays, utility rooms, and related plant areas as per specification.',
    },
    systems: [
      {
        id: 'beck-slf-36-slf-936',
        name: 'Beck Bond SLF 36 / SV Bond SLF 936',
        description: 'Self-levelling epoxy flooring system',
        applications:
          'Formulation Rooms, Aseptic Production, Injectable Manufacturing OA & Analysis Labs / Tablet / Capsule / Bottling Rooms / Packaging / Stores Loading / Unloading Bay, Utility Rooms',
      },
      {
        id: 'beck-slf-36-cs-slf-936-cs',
        name: 'Beck Bond SLF 36 CS / SV Bond SLF 936 CS',
        description: 'Granular, Multi-coloured, self-levelling epoxy flooring',
        applications: 'Packaging / Stores / Service Areas / Utility Rooms',
      },
      {
        id: 'epc-36-ep-coat-936',
        name: 'Epoxy Coating EPC 36 / SV Bond EP Coat 936',
        description: 'High abrasion resistant epoxy floor coating',
        applications: 'Packaging / Stores / Service Areas / Utility Rooms',
      },
      {
        id: 'dobeckot-underlay-9022-560',
        name:
          'Dobeckot 5022 + Hardener EH 460 + Filler / SV Bond UL 9022 A+ SV Bond UL 560 B + Filler',
        description: 'Self-levelling epoxy underlay with excellent mechanical properties',
        applications: 'Underlay for Epoxy and PU Toppings',
      },
      {
        id: 'beck-slf-as-sv-as',
        name: 'Beck Bond SLF 36 AS + Beck Bond AS 45 / SV Bond SLF 936 AS + SV Bond AS 945',
        description: 'Antistatic self-levelling epoxy flooring',
        applications: 'Solvent Extraction Area, Operation Theaters (OTs) / Flammable Liquid Handling area',
      },
    ],
  },
  {
    slug: 'polyurethane-flooring',
    title: 'Polyurethane Flooring',
    overview: {
      what: 'Waterborne polyurethane concrete and floor coating systems.',
      whereUsed:
        'Food processing, formulation, injectable manufacturing, packaging, stores, bottling, and utility areas as listed per system.',
    },
    systems: [
      {
        id: 'elancrete-mf-pu-crete-mf',
        name: 'Elancrete MF / SV PU Crete MF',
        description:
          'Waterborne polyurethane concrete flooring system. Excellent chemical & abrasion resistance.',
        applications:
          'Food Processing, Formulation Rooms, Injectable Manufacturing OA & Analysis Labs / Tablet / Capsule / Bottling Rooms / Packaging / Stores Loading / Unloading Bay, Utility Rooms, Bottling Area.',
      },
      {
        id: 'beck-pu90-2kpu990-floor',
        name: 'Beck Bond PU 90 / SV Bond 2KPU 990',
        description:
          'Two-component waterborne polyurethane floor coating. Excellent adhesion to concrete, utility & Service Areas.',
        applications: 'Packaging / Stores / Utility & Service Areas.',
      },
    ],
  },
  {
    slug: 'wall-coatings',
    title: 'Polyurethane & Acrylic Wall Coatings',
    overview: {
      what: 'Internal wall coatings for formulation, food, laboratory, and clinical environments.',
      whereUsed:
        'Formulation and food processing areas, laboratories, ICUs, operation theaters, QA & analysis labs, dairies, and bottling plants.',
    },
    systems: [
      {
        id: 'beck-pu28-pu-coat-928',
        name: 'Beck Bond PU 28 / SV Bond PU Coat 928',
        description: 'Aliphatic polyurethane semi-glossy / glossy internal wall coating',
        applications:
          'Formulation, Food Processing Areas / Laboratories / ICUs / Operation Theaters / QA & Analysis Labs',
      },
      {
        id: 'beck-pu90-2kpu990-wall',
        name: 'Beck Bond PU 90 / SV Bond 2KPU 990',
        description: 'Two-component waterborne polyurethane wall coating',
        applications: 'Production areas, Food processing Areas, Dairies, Soft-drink and bottling plants',
      },
      {
        id: 'beck-aquacoat-wallcoat-955',
        name: 'Beck Bond PU Aquacoat 55 / SV Bond PU Wallcoat 955',
        description: 'Single-component water based polyurethane coating',
        applications:
          'Formulation & Food Processing Areas / Laboratories / ICUs / Operation Theaters / QA & Analysis Labs',
      },
    ],
  },
  {
    slug: 'food-grade-systems',
    title: 'Food Grade Coating',
    overview: {
      what: 'Food-grade epoxy coating and epoxy systems for coving and painting (epoxy & kota stone pointing).',
      whereUsed:
        'Potable water and foodstuff tanks; formulation, aseptic production, QA labs, tablet/capsule/bottling, packaging, stores, loading/unloading, and utility rooms as per system.',
    },
    systems: [
      {
        id: 'fdm-46-fdg-946',
        name: 'Beck Bond FDM 46 / SV Bond FDG 946',
        description: 'High build solvent-free food grade, epoxy coating',
        applications: 'Metal / Concrete Tanks for Potable Water & Foodstuffs',
      },
      {
        id: 'epoxy-coving-painting-system',
        name:
          'Dobeckot 505 C + Hardener EH 411 + Filler + Beck Bond PU 28 / SV Bond 9505 + SV Bond 9411 + Filler + SV Bond PU Coat 928',
        description: 'Epoxy system for coving and painting',
        applications:
          'Formulation Rooms, Aseptic Production, Injectable Manufacturing QA & Analysis Labs / Tablet / Capsule / Bottling Rooms / Packaging / Stores / Loading / Unloading Bay / Utility Rooms',
      },
      {
        id: 'sv-bond-coving-products',
        name: 'SV Bond Coving Mortar (SV Bond 9022 + SV Bond 550 + SV Bond 940)',
        description:
          'Mixture of SV Bond 9022, SV Bond 550, and SV Bond 940 used to form epoxy coving at wall-floor junctions with a seamless hygienic radius.',
        applications:
          'Formulation / Aseptic / Injectable / QA & Analysis / Tablet / Capsule / Bottling / Packaging / Stores / Loading-Unloading / Utility Rooms / Food Processing Areas.',
      },
    ],
  },
];

export function getPillarBySlug(slug) {
  return PRODUCT_PILLARS.find((p) => p.slug === slug) || null;
}

export const PILLAR_NAV = PRODUCT_PILLARS.map(({ slug, title }) => ({ slug, title }));
